/* global femcare, axios, google */

femcare.storeLocator = {
    map: null,
    markers: [],
    locations: [],
    currentActiveIndex: null,

    /**
     * Initialize the store locator component.
     */
    async init() {
        this.storeLocator = document.querySelector('.store-locator');

        if (this.storeLocator) {
            this.searchInput = document.querySelector('.store-locator__search input');
            this.suggestions = document.querySelector('.store-locator__suggestions');
            this.suggestionsBackdrop = document.querySelector('.store-locator__suggestions-backdrop');
            this.suggestionsStores = document.querySelector('.store-locator__suggestions-stores');
            this.suggestionsCities = document.querySelector('.store-locator__suggestions-cities');
            this.suggestionsEmpty = document.querySelector('.store-locator__suggestions-empty');

            this.infoCount = document.querySelector('.store-locator__info-count');
            this.mapContainer = document.getElementById('store-locator-map');
            this.cardList = document.querySelector('.store-locator__list');

            this.labelShow = this.storeLocator.getAttribute('data-label-show') || 'Show on Map';
            this.labelDirections = this.storeLocator.getAttribute('data-label-directions') || 'Get Directions';
            this.labelEmptySearch = this.storeLocator.getAttribute('data-label-empty-search') || 'No stores found with this location.';

            await this.fetchLocations();
            this.initMap();
            this.addMarkers();
            this.renderLocationList();
            this.renderSearchResults();
            this.bindEvents();
            this.bindMobileNavigation();
        }
    },

    /**
     * Fetch locations from the backend using Axios.
     */
    async fetchLocations() {
        try {
            const response = await axios.get('https://api.npoint.io/4e3b969eadb89e29d3ac');
            this.locations = response.data.map((loc) => ({
                ...loc,
                latitude: parseFloat(loc.latitude),
                longitude: parseFloat(loc.longitude),
            }));
        } catch (error) {
            this.handleMapError();
        }
    },

    /**
     * Initialize the map using Google Maps API.
     */
    initMap() {
        if (!this.locations.length) {
            this.handleMapError();
            return;
        }

        this.map = new google.maps.Map(this.mapContainer, {
            zoom: 2,
            center: { lat: 0, lng: 0 }
        });

        // Fit bounds to all valid locations
        const bounds = new google.maps.LatLngBounds();
        this.locations.forEach((loc) => {
            if (!isNaN(loc.latitude) && !isNaN(loc.longitude)) {
                bounds.extend({ lat: loc.latitude, lng: loc.longitude });
            }
        });

        if (!bounds.isEmpty()) {
            this.map.fitBounds(bounds);
            const maxZoom = 12;
            if (this.map.getZoom() > maxZoom) {
                this.map.setZoom(maxZoom);
            }
        } else {
            this.handleMapError();
        }
    },

    /**
     * Add markers and clusters to the map.
     */
    addMarkers() {
        const rawMarkerIconSvg = `
            <svg width="23" height="31" viewBox="0 0 23 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.88799 30.0899C10.6764 31.0775 12.1722 31.0775 12.9606 30.0899C17.1279 24.8694 22.8486 17.0053 22.8486 11.4243C22.8486 5.11483 17.7338 0 11.4243 0C5.11483 0 0 5.11483 0 11.4243C0 17.0053 5.72065 24.8694 9.88799 30.0899ZM11.4243 16.451C14.2005 16.451 16.451 14.2005 16.451 11.4243C16.451 8.64818 14.2005 6.39766 11.4243 6.39766C8.64818 6.39766 6.39766 8.64818 6.39766 11.4243C6.39766 14.2005 8.64818 16.451 11.4243 16.451Z" fill="url(#paint0_linear_9077_15637)"/>
                <defs>
                    <linearGradient id="paint0_linear_9077_15637" x1="0" y1="15.4153" x2="22.8486" y2="15.4153" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#D11A88"/>
                        <stop offset="0.494792" stop-color="#DA3482"/>
                        <stop offset="1" stop-color="#DA291C"/>
                    </linearGradient>
                </defs>
            </svg>
        `;

        const rawSelectedMarkerIconSvg = `
            <svg width="23" height="31" viewBox="0 0 23 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M9.88799 30.0899C10.6764 31.0775 12.1722 31.0775 12.9606 30.0899C17.1279 24.8694 22.8486 17.0053 22.8486 11.4243C22.8486 5.11483 17.7338 0 11.4243 0C5.11483 0 0 5.11483 0 11.4243C0 17.0053 5.72065 24.8694 9.88799 30.0899ZM11.4243 16.451C14.2005 16.451 16.451 14.2005 16.451 11.4243C16.451 8.64818 14.2005 6.39766 11.4243 6.39766C8.64818 6.39766 6.39766 8.64818 6.39766 11.4243C6.39766 14.2005 8.64818 16.451 11.4243 16.451Z" fill="#001E62"/>
            </svg>
        `;

        const rawClusterIconSvg = `
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="16" fill="url(#paint0_linear_9225_4756)"/>
                <defs>
                    <linearGradient id="paint0_linear_9225_4756" x1="0" y1="16" x2="32" y2="16" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#D11A88"/>
                        <stop offset="0.494792" stop-color="#DA3482"/>
                        <stop offset="1" stop-color="#DA291C"/>
                    </linearGradient>
                </defs>
            </svg>
        `;

        const encodedMarkerIconSvg = encodeURIComponent(rawMarkerIconSvg).replace(/%20/g, ' ');
        const encodedSelectedMarkerIconSvg = encodeURIComponent(rawSelectedMarkerIconSvg).replace(/%20/g, ' ');
        const encodedClusterIconSvg = encodeURIComponent(rawClusterIconSvg).replace(/%20/g, ' ');

        this.defaultMarkerIcon = `data:image/svg+xml;charset=UTF-8,${encodedMarkerIconSvg}`;
        this.selectedMarkerIcon = `data:image/svg+xml;charset=UTF-8,${encodedSelectedMarkerIconSvg}`;

        // Create markers for each location.
        const markers = this.locations.map((loc, index) => {
            if (isNaN(loc.latitude) || isNaN(loc.longitude)) {
                return null;
            }

            const marker = new google.maps.Marker({
                position: { lat: loc.latitude, lng: loc.longitude },
                icon: this.defaultMarkerIcon
            });

            marker.addListener('click', () => this.handleMarkerClick(index));
            return marker;
        }).filter(Boolean);

        // Save the markers so we can update their icons later.
        this.markers = markers;

        // Create the marker cluster.
        /* global markerClusterer */
        this.markerCluster = new markerClusterer.MarkerClusterer({
            markers,
            map: this.map,
            maxZoom: 14,
            gridSize: 60,
            renderer: {
                render({ count, position }) {
                    const label = {
                        text: String(count),
                        color: 'white',
                        fontSize: '14px',
                    };
                    const icon = {
                        url: `data:image/svg+xml;charset=UTF-8,${encodedClusterIconSvg}`,
                        scaledSize: new google.maps.Size(32, 32),
                    };
                    return new google.maps.Marker({
                        position,
                        label,
                        icon,
                    });
                }
            }
        });
    },

    /**
     * Create the list of store cards in a single list.
     */
    renderLocationList() {
        this.cardList.innerHTML = '';

        this.locations.forEach((loc, index) => {
            const card = this.createCard(loc, index);
            this.cardList.appendChild(card);
        });

        this.updateVisibleLocations();
    },

    /**
     * Create a single card element.
     */
    createCard(location, index) {
        const card = document.createElement('li');
        card.className = 'store-locator__item';
        card.setAttribute('data-index', index);

        card.innerHTML = `
            <h3 class="store-locator__item-title">${location.store}</h3>
            <p class="store-locator__item-address">${location.address}, ${location.city}, ${location.state}</p>
            <p class="store-locator__item-phone">
                Phone number:
                <a href="tel:${location.phone}">${location.phone}</a>
            </p>
            <div class="store-locator__item-actions">
                <button class="btn btn-primary store-locator__item-button" data-index="${index}">
                    ${this.labelShow}
                </button>
                <a class="btn store-locator__item-button store-locator__item-button--directions"
                    data-index="${index}"
                    href="${location.directionsUrl}"
                    target="_blank">
                    <i class="icon-external-link"></i>
                    ${this.labelDirections}
                </a>
            </div>
        `;

        card.querySelector('.store-locator__item-button').addEventListener('click', () => {
            if (window.innerWidth < 768) {
                this.mapContainer.classList.add('displayed');
                this.cardList.classList.add('hidden');

                const listBtnItem = document.querySelector('.store-locator-nav__button--list')?.parentElement;
                const mapBtnItem = document.querySelector('.store-locator-nav__button--map')?.parentElement;
                if (listBtnItem && mapBtnItem) {
                    mapBtnItem.classList.add('store-locator-nav__item--active');
                    listBtnItem.classList.remove('store-locator-nav__item--active');
                }

                setTimeout(() => {
                    this.handleMarkerClick(index);
                }, 50);
            } else {
                this.handleMarkerClick(index);
            }
        });

        return card;
    },

    /**
     * Handles events after marker is selected.
     * Also updates marker icons so that only the previously selected and the newly selected markers are updated.
     */
    handleMarkerClick(index) {
        const location = this.locations[index];
        const cards = this.cardList.querySelectorAll('.store-locator__item');
        const activeCard = this.cardList.querySelector(`[data-index="${index}"]`);

        // Update marker icons:
        // If a marker was previously selected and it's not the same as the new one, revert its icon.
        if (this.currentActiveIndex !== null && this.currentActiveIndex !== index) {
            const prevMarker = this.markers[this.currentActiveIndex];
            if (prevMarker) {
                prevMarker.setIcon(this.defaultMarkerIcon);
            }
        }
        // Set the new marker's icon to the selected version.
        if (this.markers[index]) {
            this.markers[index].setIcon(this.selectedMarkerIcon);
        }
        // Update the current active index.
        this.currentActiveIndex = index;

        // Highlight the correct card in the main list.
        cards.forEach((card, i) => {
            card.classList.toggle('store-locator__item--active', i === index);
        });

        // Scroll the active card into centar of the container on desktop.
        if (window.innerWidth > 768) {
            const listWrapper = document.querySelector('.store-locator__list-wrapper');
            const containerRect = listWrapper.getBoundingClientRect();
            const cardRect = activeCard.getBoundingClientRect();

            const currentScroll = listWrapper.scrollTop;
            const offset = (cardRect.top - containerRect.top) - (containerRect.height / 2) + (cardRect.height / 2);
            listWrapper.scrollTo({ top: currentScroll + offset });
        }

        // Zoom the map to the selected marker.
        this.map.setCenter({ lat: location.latitude, lng: location.longitude });
        this.map.setZoom(12);

        // Mobile-only functionalities: show active card under map and switch to map view.
        if (window.innerWidth < 768) {
            const mapCardContainer = document.querySelector('.store-locator__active-card');
            if (mapCardContainer && activeCard) {
                const classes = activeCard.className;
                const dataIndex = activeCard.getAttribute('data-index');
                mapCardContainer.innerHTML = `
                    <div class="${classes}" data-index="${dataIndex}">
                        ${activeCard.innerHTML}
                    </div>
                `;
                mapCardContainer.classList.remove('hidden');

                // Use a short delay to ensure the content is rendered,
                // then scroll the newly added element into view.
                setTimeout(() => {
                    const newActiveCard = mapCardContainer.firstElementChild;
                    if (newActiveCard) {
                        newActiveCard.scrollIntoView({ block: 'end', behavior: 'smooth' });
                    }
                }, 50);
            }
        }
    },

    /**
     * Update the visible locations count based on currently shown cards.
     */
    updateVisibleLocations() {
        const visibleCount = this.cardList.querySelectorAll('.store-locator__item:not(.hidden)').length;
        this.infoCount.textContent = visibleCount;
    },

    /**
     * Renders all store suggestion elements initially.
     * Future suggestion types (like cities) can be rendered similarly.
     */
    renderSearchResults() {
        // Clear the suggestions list.
        this.suggestionsStores.innerHTML = '';

        // Render a suggestion for each location.
        this.locations.forEach((loc, i) => {
            const li = document.createElement('li');
            li.className = 'store-locator__suggestion';
            li.setAttribute('data-index', i);
            li.textContent = loc.store;
            li.addEventListener('click', () => {
                this.searchInput.value = loc.store;
                this.suggestions.classList.add('hidden');
                this.suggestionsBackdrop.classList.add('hidden');
                this.handleMarkerClick(i);
            });
            this.suggestionsStores.appendChild(li);
        });

        // Create the "No results" element once and append it as the last child.
        this.noResultsEl = document.createElement('li');
        this.noResultsEl.className = 'store-locator__suggestion store-locator__suggestion--empty hidden';
        this.noResultsEl.textContent = this.labelEmptySearch;
        this.suggestionsStores.appendChild(this.noResultsEl);
    },

    /**
     * Handles filtering of pre-rendered suggestions based on the search query.
     * Only shows/hides suggestions by toggling the "hidden" class.
     */
    handleSearch() {
        const query = this.searchInput.value.toLowerCase().trim();
        const suggestionItems = Array.from(
            this.suggestionsStores.querySelectorAll('.store-locator__suggestion:not(.store-locator__suggestion--empty)')
        );
        let visibleCount = 0;

        suggestionItems.forEach(item => {
            if (item.textContent.toLowerCase().includes(query)) {
                item.classList.remove('hidden');
                visibleCount++;
            } else {
                item.classList.add('hidden');
            }
        });

        // Toggle the "No results" element:
        if (query !== '' && visibleCount === 0) {
            this.noResultsEl.classList.remove('hidden');
        } else {
            this.noResultsEl.classList.add('hidden');
        }

        // Show the suggestions container/backdrop when there is a query;
        // otherwise, hide them.
        if (query !== '') {
            this.suggestions.classList.remove('hidden');
            this.suggestionsBackdrop.classList.remove('hidden');
        } else {
            this.suggestions.classList.add('hidden');
            this.suggestionsBackdrop.classList.add('hidden');
        }
    },

    /**
     * Handle mobile navigation between List view and Map view.
     */
    bindMobileNavigation() {
        const listBtn = document.querySelector('.store-locator-nav__button--list');
        const mapBtn = document.querySelector('.store-locator-nav__button--map');

        listBtn.addEventListener('click', () => {
            this.mapContainer.classList.remove('displayed');
            this.cardList.classList.remove('hidden');

            listBtn.parentElement.classList.add('store-locator-nav__item--active');
            mapBtn.parentElement.classList.remove('store-locator-nav__item--active');
        });

        mapBtn.addEventListener('click', () => {
            this.mapContainer.classList.add('displayed');
            this.cardList.classList.add('hidden');

            mapBtn.parentElement.classList.add('store-locator-nav__item--active');
            listBtn.parentElement.classList.remove('store-locator-nav__item--active');
        });
    },

    /**
     * Bind events for search, outside clicks for suggestions, etc.
     */
    bindEvents() {
        if (this.searchInput) {
            // Wrap handleSearch in a debounced function (300ms delay)
            const debouncedSearch = femcare.shared.util.debounce(() => this.handleSearch(), 300);
            this.searchInput.addEventListener('input', debouncedSearch);
        }

        document.addEventListener('click', (event) => {
            if (!this.searchInput || !this.suggestions) {
                return;
            }
            const clickedInsideInput = this.searchInput.contains(event.target);
            const clickedInsideSuggestions = this.suggestions.contains(event.target);
            if (!clickedInsideInput && !clickedInsideSuggestions) {
                this.suggestions.classList.add('hidden');
                this.suggestionsBackdrop.classList.add('hidden');
            }
        });
    },

    /**
     * Handle map errors (e.g. no valid locations).
     */
    handleMapError() {
        const mapErrorText = this.mapContainer.getAttribute('data-map-error') || 'An error occurred.';
        this.mapContainer.classList.add('store-locator__map--error');
        this.mapContainer.innerHTML = `
            <i class="icon-validation-error"></i>
            <p>${mapErrorText}</p>
        `;
    },
};
